let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iBJl3")).then(() => parcelRequire('iwR1g'));